function PartnerItem({
  href,
  imgSrc,
  alt,
  tabIndex = -1,
  ariaHidden = "true",
  ariaDescribedBy,
  dataSlickIndex,
  isCurrent,
}) {
  return (
    <div
      className={`partenaires-item-big-ctn flexbox slick-slide ${isCurrent ? 'slick-current slick-active' : ''}`}
      style={{
        flex: '0 0 auto',
        width: '100%',
      }}
      tabIndex={tabIndex}
      role="option"
      aria-describedby={ariaDescribedBy}
      data-slick-index={dataSlickIndex}
      aria-hidden={ariaHidden}
    >
      <a
        className="partenaires-item flexbox items-center justify-center overflow-hidden"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        tabIndex={tabIndex}
        style={{
          width: '100%',
          height: '100px',
          maxWidth: '403px',
          margin: '0 auto',
          display: 'flex',
        }}
      >
        <div
          className="partenaires-item-inner"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={imgSrc}
            alt={alt}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </div>
      </a>
    </div>
  );
}

export default PartnerItem;
